export default function StarModal() {
  return <div className="p-4 w-[450px]">별점 모달 창</div>;
}
